/// <reference path="../include.ts" />

namespace gpx_visualizer_phase2 {

	export class Bounds {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(topLeft:LatLng, bottomRight:LatLng) {
			this.topLeft = topLeft;
			this.bottomRight = bottomRight;

			this.center = new LatLng(
				(this.topLeft.getLat() + this.bottomRight.getLat()) * 0.5,
				(this.topLeft.getLng() + this.bottomRight.getLng()) * 0.5,
			);
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public calcPixelCoord(zoomLevel:number):Bounds {
			this.topLeft.calcPixelCoord(zoomLevel);
			this.bottomRight.calcPixelCoord(zoomLevel);

			this.center.calcPixelCoord(zoomLevel);

			this.pixelWidth = this.bottomRight.getPixel().x - this.topLeft.getPixel().x;
			this.pixelHeight = this.bottomRight.getPixel().y - this.topLeft.getPixel().y;

			return this;
		}

		public getTopLeft():LatLng {
			return this.topLeft;
		}

		public getBottomRight():LatLng {
			return this.bottomRight;
		}

		public getCenter():LatLng {
			return this.center;
		}

		public getPixelWidth():number {
			return this.pixelWidth;
		}

		public getPixelHeight():number {
			return this.pixelHeight;
		}

		public static fromTile(tileTopLeft:THREE.Vector2, tileBottomRight:THREE.Vector2, zoomLevel:number):Bounds {
			const topLeft = Unit.tileToLatLng(tileTopLeft.x, tileTopLeft.y, zoomLevel);
			const bottomRight = Unit.tileToLatLng(tileBottomRight.x + 1, tileBottomRight.y + 1, zoomLevel);
			return new Bounds(topLeft, bottomRight);
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private topLeft:LatLng;
		private bottomRight:LatLng;

		private center:LatLng;

		private pixelWidth:number;
		private pixelHeight:number;
	}
}
